import { DatePipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { MatIcon } from '@angular/material/icon';

import { formatDate } from '@lib/commons/util-functions/format-date.function';

import { AppointmentSuggestionResponse } from '@lib/core/models/create-appointment.interface';

@Component({
  selector: 'hm-suggestion-item',
  standalone: true,
  imports: [MatIcon, DatePipe, NgClass, TranslatePipe],
  templateUrl: './suggestion-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SuggestionItemComponent {
  protected readonly formatDate = formatDate;

  suggestionData = input.required<AppointmentSuggestionResponse>();
  selected = input<boolean>(false);

  selectionChange = output<AppointmentSuggestionResponse>();

  protected selectSuggestion() {
    this.selectionChange.emit(this.suggestionData());
  }
}
